import APIManager from "./apiManager";

export const doCheckLogin = (userData, setUsuario) => {
  setUsuario({nombre: 'Usuario de Prueba'});
  // APIManager.sendRequest('post', 'usuario', 'me', {}, (response) => {
  //   if (response.success) {
  //     setUsuario(response.data.usuario);
  //   } else {
  //     setUsuario(null);
  //   }
  // });
}
